import React, {Component} from "react"
import PropTypes from "prop-types"
import {translate} from "react-i18next"

import Button from "../Button"
import env from "../../env"

import styles from "./styles.css"

class FAQFlyout extends Component {
  static propTypes = {
    categories: PropTypes.array,
    lang: PropTypes.string,
    push: PropTypes.func,
  }

  static defaultProps = {
    categories: [],
    lang: null,
    push: () => console.log(arguments),
  }

  state = {
    active: false
  }

  _toggleActive() {
    this.setState(prevState => {
      return {
        ...prevState,
        active: !prevState.active
      }
    })
  }

  _goto(categoryId, articleId) {
    this._toggleActive()

    this.props.push(
      `/${this.props.lang}/faq/articles/${categoryId}#article-${articleId}`
    )
  }

  renderCategories(categories) {
    return (
      <ul>
        {categories.map(category => {
          return (
            <li key={`faq-cat-${category.term_id}`}>
              {category.name}
              <ol>
                {category.articles.map(article => {
                  return (
                    <li key={`faq-${article.ID}`}>
                      <button
                        onClick={() => this._goto(category.term_id, article.ID)}
                      >
                        {article.post_title}
                      </button>
                    </li>
                  )
                })}
              </ol>
            </li>
          )
        })}
      </ul>
    )
  }

  render() {
    const {categories, t} = this.props

    if (categories.length === 0) return null

    return (
      <div className={styles.FAQFlyout}>
        <div className={`content ${this.state.active ? "active" : ""}`}>
          <h3>{t("FAQ")}</h3>
          <div className="inner">{this.renderCategories(categories)}</div>
        </div>
        <Button
          className={`mail-link ${this.state.active ? "active" : ""}`}
          theme="dark"
          href={`mailto:${env.CONTACT_MAIL_ADDRESS}`}
        >
          {t("Kontaktiere uns")}
        </Button>
        <button onClick={() => this._toggleActive()} className="trigger">
          {this.state.active ? (
            <i className="icon-close" />
          ) : (
            <i className="icon-tip" />
          )}
        </button>
      </div>
    )
  }
}

export default translate()(FAQFlyout)



// WEBPACK FOOTER //
// ./src/components/FAQFlyout/index.js